Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _constants = require('../../constants');

exports['default'] = _react.PropTypes.oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/shapes/AnchorDirectionShape.js
 ** module id = 1498
 ** module chunks = 0
 **/